<template>
    <div v-show="show" class="login-knsh common-dialog">
        <div class="dialog">
            <div class="title">
                <span>{{ message.title }}</span>
            </div>
            <div class="user-data">
                <span class="prompt">{{ message.prompt }}</span>
                <span class="warning">{{ message.warning }}</span>
                <input v-model="account" :placeholder="message.placeholderAccount" />
                <input type="password" v-model="password" :placeholder="message.placeholderPassword" />
            </div>
            <div class="row">
                <div class="remember" :class="{ 'on': isRemember }" @click="switchIsRemember"></div>
                <div class="sign-up" @click="handleSignUp"></div>
                <div class="forget-password" @click="handleForgetPassword"></div>
            </div>
            <div class="buttons">
                <div class="cancel" @click="handleCancel">{{ message.cancel }}</div>
                <div class="confirm" @click="handleConfirm">{{ message.confirm }}</div>
            </div>
        </div>
    </div>
</template>

<script>
import { API_POST_LOGIN } from '../../../js/api';
import { useUserStore } from '../../../js/user_data'
import AppRenderer from '../../../js/app_renderer';
import { LOGIN_REQUEST } from '../../../js/api/login';
import EventBus from '../../../js/event_bus';


export default {
    name: "LoginKnsh",
    data() {
        return {
            show: false,
            isRemember: false,
            account: "",
            password: "",
            message: {
                title: "登入",
                prompt: "請輸入帳號/密碼",
                warning: "",
                cancel: "取消",
                confirm: "確定",
                placeholderAccount: "請在此輸入帳號",
                placeholderPassword: "請在此輸入密碼"
            },
        }
    },
    methods: {
        async handleConfirm() {
            const response = await API_POST_LOGIN(this.account, this.password);
            const json = await response.json();
            //console.log("response:", json);

            switch (json.Msg) {
                case "OK":
                    const USER_DATA = useUserStore();
                    USER_DATA.userId = json.UUID;
                    USER_DATA.userName = json.Name;

                    if (this.isRemember) {
                        USER_DATA.savedAccount = this.account;
                        USER_DATA.savedPassword = this.password;
                    } else {
                        USER_DATA.savedAccount = "";
                        USER_DATA.savedPassword = "";
                    }
                    this.show = false;


                    break;
                case "TEMP":
                    this.message.warning = "帳號待認証!";
                    setTimeout(() => {
                        AppRenderer.Instance.openWebSite(LOGIN_REQUEST.ACTIVE_ACCOUNT_URL);
                    }, 1000);
                    break;
                case "NG":
                    this.message.warning = "帳號密碼有誤";
                    break;
                case "NOACCESS":
                    this.message.warning = "帳密正確，但此帳號並非教師身分，無法使用!";
                    break;
            }
        },
        switchIsRemember() {
            this.isRemember = !this.isRemember;
        },
        handleSignUp() {
            AppRenderer.Instance.openWebSite(LOGIN_REQUEST.SIGN_UP_URL);
        },
        handleForgetPassword() {
            AppRenderer.Instance.openWebSite(LOGIN_REQUEST.SEND_PWD_URL);
        },
        handleCancel() {
            EventBus.getInstance().getAppRefs().loginType.show = true;
            this.show = false;
        }
    },
    mounted() {
        const USER_DATA = useUserStore();
        this.isRemember = USER_DATA.savedAccount.length > 0 && USER_DATA.savedPassword.length > 0;
        if (this.isRemember) {
            this.account = USER_DATA.savedAccount;
            this.password = USER_DATA.savedPassword;
        }
    }
}
</script>

<style scoped>
.login-knsh {
    display: grid;
    grid-template-columns: 1fr 600px 1fr;
    grid-template-rows: repeat(16, 1fr);
    position: absolute;
    z-index: 999;
    width: 100%;
    height: 100%;

    background-color: #0000007f
}

.dialog {
    grid-column-start: 2;
    grid-column-end: 3;
    grid-row-start: 6;
    grid-row-end: 11;

    min-width: 600px;
    min-height: 320px;

    background-color: #D7F1CD;

    display: flex;
    flex-direction: column;
    justify-content: flex-start;
}

.title {
    background-color: #8ACC9F;
    color: white;
    font-size: 1.5rem;
    height: 2.5rem;
    line-height: 2.5rem;
}

.user-data {
    display: flex;
    flex-direction: column;
    height: 48%;
    justify-content: space-around;
    align-items: center;

}

.user-data .prompt {
    font-size: 1.5rem;
    font-weight: bold;
    color: #808080;
}

.user-data input {
    font-size: 1.2rem;
    width: 80%;
}

.row {
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin-top: 10px;
}

.buttons {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    margin-top: 10px;
}

.buttons div {
    background-color: #04AAAF;
    color: white;
    width: 80px;
    height: 32px;
    line-height: 32px;
    border-radius: 0.5rem;
}

.remember {
    background-image: url("../../../assets/login/login_remember.png");
    width: 110px;
    height: 34px;
    background-repeat: no-repeat;
    background-size: contain;
}

.remember.on {
    background-image: url("../../../assets/login/login_remember_selected.png");
}

.sign-up {
    background-image: url("../../../assets/login/login_add.png");
    width: 120px;
    height: 34px;
    background-repeat: no-repeat;
    background-size: contain;
}

.forget-password {
    background-image: url("../../../assets/login/login_forget.png");
    width: 120px;
    height: 34px;
    background-repeat: no-repeat;
    background-size: contain;
}

.warning {
    color: red;
    height: 21px;
}
</style>